"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAccountIndex = buildAccountIndex;
exports.validateAccountTree = validateAccountTree;
exports.postableAccounts = postableAccounts;
const NORMAL_BALANCES = ['debit', 'credit', 'mixed'];
const STATEMENTS = ['BS', 'PL'];
function buildAccountIndex(accounts) {
    const index = new Map();
    for (const account of accounts) {
        index.set(account.code, account);
    }
    return index;
}
/**
 * يتحقق من سلامة دليل الحسابات قبل اعتماده لشركة:
 * أكواد فريدة، أب موجود، لا دورات، الحسابات الأب غير قابلة للترحيل،
 * والأوراق الطرفية قابلة للترحيل. يُرجع كل المشاكل لا أولها.
 */
function validateAccountTree(accounts) {
    const issues = [];
    if (accounts.length === 0) {
        return [{ code: 'EMPTY_TREE', message: 'chart of accounts is empty' }];
    }
    const byCode = new Map();
    for (const account of accounts) {
        if (byCode.has(account.code)) {
            issues.push({
                code: 'DUPLICATE_CODE',
                message: 'duplicated account code ' + account.code,
                accountCode: account.code,
            });
            continue;
        }
        byCode.set(account.code, account);
    }
    const childCount = new Map();
    for (const account of accounts) {
        if (account.parentCode) {
            childCount.set(account.parentCode, (childCount.get(account.parentCode) ?? 0) + 1);
        }
    }
    for (const account of accounts) {
        if (!NORMAL_BALANCES.includes(account.normalBalance)) {
            issues.push({
                code: 'INVALID_NORMAL_BALANCE',
                message: 'invalid normal_balance on ' + account.code,
                accountCode: account.code,
            });
        }
        if (!STATEMENTS.includes(account.statement)) {
            issues.push({
                code: 'INVALID_STATEMENT',
                message: 'invalid statement on ' + account.code,
                accountCode: account.code,
            });
        }
        const hasChildren = (childCount.get(account.code) ?? 0) > 0;
        if (hasChildren && account.isPostable) {
            issues.push({
                code: 'PARENT_IS_POSTABLE',
                message: 'parent account ' + account.code + ' must not be postable',
                accountCode: account.code,
            });
        }
        if (!hasChildren && !account.isPostable) {
            issues.push({
                code: 'LEAF_NOT_POSTABLE',
                message: 'leaf account ' + account.code + ' must be postable',
                accountCode: account.code,
            });
        }
        const seen = new Set([account.code]);
        let parentCode = account.parentCode;
        while (parentCode) {
            const parent = byCode.get(parentCode);
            if (!parent) {
                issues.push({
                    code: 'MISSING_PARENT',
                    message: 'account ' + account.code + ' references missing parent ' + parentCode,
                    accountCode: account.code,
                });
                break;
            }
            if (seen.has(parentCode)) {
                issues.push({
                    code: 'PARENT_CYCLE',
                    message: 'cycle detected at account ' + account.code,
                    accountCode: account.code,
                });
                break;
            }
            seen.add(parentCode);
            parentCode = parent.parentCode;
        }
    }
    return issues;
}
function postableAccounts(accounts) {
    return accounts.filter((account) => account.isPostable);
}
//# sourceMappingURL=account-tree.js.map